import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Modal, Empty } from "../components/ui";
import { Save, FileText, RefreshCw } from "lucide-react";
import { downloadPDF } from "../lib/pdf";

const FIELDS = [
  { key: "previous_actions", label: "1. Estado de acciones de revisiones anteriores" },
  { key: "context_changes", label: "2. Cambios en cuestiones externas e internas" },
  { key: "objectives_compliance", label: "3. Cumplimiento de objetivos ambientales" },
  { key: "performance", label: "4. Desempeño ambiental (ICA, KPIs)" },
  { key: "audit_results", label: "5. Resultados de auditorías" },
  { key: "provider_evaluation", label: "6. Evaluación de proveedores" },
  { key: "improvement_opportunities", label: "7. Oportunidades de mejora continua" },
  { key: "resources", label: "8. Recursos necesarios" },
  { key: "management_commitments", label: "9. Compromisos de la Dirección" },
];

export default function ManagementReview() {
  const [history, setHistory] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ period: new Date().getFullYear() });
  const [autoFilling, setAutoFilling] = useState(false);
  const [generating, setGenerating] = useState(false);

  async function loadHistory() {
    const { data } = await api.get("/data/management_reviews");
    setHistory(data);
  }
  useEffect(() => { loadHistory(); }, []);

  async function autoFill() {
    setAutoFilling(true);
    try {
      const { data } = await api.get("/pdf/management-review/autofill");
      setForm((f) => ({ ...f, ...data }));
    } finally { setAutoFilling(false); }
  }

  async function openNew() {
    setForm({ period: new Date().getFullYear() });
    setShowForm(true);
    await autoFill();
  }

  async function generate() {
    setGenerating(true);
    try {
      await downloadPDF("/pdf/management-review", form, `revision_direccion_${form.period}.pdf`);
      setShowForm(false);
      loadHistory();
    } finally { setGenerating(false); }
  }

  return (
    <div data-testid="management-review">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="card-h1" style={{ margin: 0 }}>Revisión por la Dirección</h2>
          <div className="text-xs text-dim mt-2">ISO 14001:2015 — Cláusula 9.3</div>
        </div>
        <button className="btn btn-primary" onClick={openNew} data-testid="new-review-btn">
          <FileText size={14} /> Nueva Revisión
        </button>
      </div>

      <div className="table-wrap">
        <table className="table">
          <thead><tr><th>Período</th><th>ICA al momento</th><th>Generado por</th><th>Fecha</th><th>Status</th></tr></thead>
          <tbody>
            {!history.length ? <tr><td colSpan={5}><Empty title="Sin revisiones" sub="Genera la primera revisión por la Dirección." /></td></tr> : history.map((r) => (
              <tr key={r.id}>
                <td><b>{r.period}</b></td>
                <td>{r.ecs_snapshot}</td>
                <td>{r.created_by_name}</td>
                <td className="text-xs">{new Date(r.created_at).toLocaleDateString("es-MX")}</td>
                <td><span className="badge badge-green">{r.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Modal open={showForm} onClose={() => setShowForm(false)} title="Nueva Revisión por la Dirección" size="xl" testId="review-modal">
        <div className="grid gap-3">
          <div className="flex items-center justify-between mb-2">
            <div>
              <label className="label">Período</label>
              <input className="input" value={form.period || ""} onChange={(e) => setForm({ ...form, period: e.target.value })} style={{ width: 200 }} />
            </div>
            <button className="btn btn-sm" onClick={autoFill} disabled={autoFilling} data-testid="autofill-btn">
              {autoFilling ? <span className="spinner" /> : <><RefreshCw size={14} /> Auto-llenar desde sistema</>}
            </button>
          </div>
          {FIELDS.map((f) => (
            <div key={f.key}>
              <label className="label">{f.label}</label>
              <textarea
                className="textarea"
                rows={3}
                value={form[f.key] || ""}
                onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
                data-testid={`review-field-${f.key}`}
              />
            </div>
          ))}
          <div className="flex justify-end gap-2 mt-3">
            <button className="btn" onClick={() => setShowForm(false)}>Cancelar</button>
            <button className="btn btn-primary" onClick={generate} disabled={generating} data-testid="generate-review-btn">
              {generating ? <span className="spinner" /> : <><Save size={14} /> Generar PDF y guardar</>}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
